import * as StoreBreadcrumbLayout from './Store';

export const atualizarCabecalho = (item) => async (dispatch) => {
      if (item) {
        dispatch(StoreBreadcrumbLayout.atualizarCabecalho(item));
      } 
  };